export default __webpack_public_path__ + "a1e9b67c81ea8f5850f3dfcf2a50a1be.png";